import { BankTransfer, Create, Receive, View } from "../Components/index.js";

export default [
    {
        path: "/voucher/account/journal/create",
        component: Create,
        name: "account.voucher.journal.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/account/receive-journal/create",
        component: Receive,
        name: "account.voucher.receive.journal.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/account/journal/:id/view",
        component: View,
        name: "account.voucher.journal.view",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/account/journal/bank-transfer",
        component: BankTransfer,
        name: "account-voucher-journal-bank-transfer",
        meta: {
            requiresAuth: true,
        },
    },
];
